// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let AreasCriteria = require("./AreasCriteria.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("../common/ErrorHandling/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let BuyerNeedAreas_buyerNeedV5_graphql = require("../../__generated__/BuyerNeedAreas_buyerNeedV5_graphql.bs.js");

let convertFragment = BuyerNeedAreas_buyerNeedV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, BuyerNeedAreas_buyerNeedV5_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(BuyerNeedAreas_buyerNeedV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, BuyerNeedAreas_buyerNeedV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(BuyerNeedAreas_buyerNeedV5_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function BuyerNeedAreas(props) {
  let buyerNeed = RescriptRelay_Fragment.useFragment(BuyerNeedAreas_buyerNeedV5_graphql.node, convertFragment, props.buyerNeed);
  let areas = Stdlib_Array.filterMap(buyerNeed.areas.edges, x => x).map(param => param.node);
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "buyer need areas",
    children: JsxRuntime.jsx(AreasCriteria.make, {
      areas: areas.map(a => a.fragmentRefs)
    })
  });
}

let make = BuyerNeedAreas;

exports.Fragment = Fragment;
exports.make = make;
/* AreasCriteria Not a pure module */
